import { jsx } from "react/jsx-runtime";
import { AMP_TOOLTIP_ID, ModalButtonRow, Button } from "@flatfile/design-system";
import { named } from "../../../utils/named.js";
import AlertModal, { Underline } from "./AlertModal.js";
import { useTranslation, Trans } from "react-i18next";
const PasteAlertModal = (props) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx(
    AlertModal,
    {
      "data-testid": "tt-paste-alert-modal",
      text: {
        heading: t("sheet.table.modals.pasteAlert.heading"),
        description: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
          Trans,
          {
            i18nKey: "sheet.table.modals.pasteAlert.description",
            components: {
              1: /* @__PURE__ */ jsx(
                Underline,
                {
                  "data-tooltip-id": AMP_TOOLTIP_ID,
                  "data-tooltip-content": t(
                    "sheet.table.modals.pasteAlert.tooltip"
                  ),
                  children: "intelligently modify"
                }
              )
            }
          }
        ) })
      },
      children: /* @__PURE__ */ jsx(ModalButtonRow, { children: /* @__PURE__ */ jsx(
        Button,
        {
          variant: "warning",
          onPress: props.onClose,
          label: t("sheet.table.modals.pasteAlert.dismissButton")
        }
      ) })
    }
  );
};
named("PasteAlertModal", PasteAlertModal);
export {
  PasteAlertModal as default
};
